import apiClient from "./apiClient";

export const getConnections = async () => {
  try {
    const res = await apiClient.get("/oauth/connections");
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const disconnectAccount = async (provider) => {
  try {
    const res = await apiClient.delete(`/oauth/connections/${provider}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};
